import React, { useState, useEffect, useMemo } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	Nav,
	NavItem,
	NavLink,
} from 'reactstrap';

import classnames from 'classnames';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { setRequireCloseModal } from '../../../../slices/screen/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewScreen, updateScreen } from '../../../../slices/thunks';
import { getFieldList } from '../../../../helpers/screen/backend_helper';
import { set } from 'lodash';
import { Select } from '@mantine/core';

const ScreenForm = ({ dataScreen, isEdit, handleToggleModal, isOpen }) => {
	const dispatch = useDispatch();
	const [activeTab, setActiveTab] = useState('1');

	const [fieldsList, setFieldsList] = useState([]);

	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	const selectorScreen = createSelector(
		state => state.Screen,
		screen => ({
			isAdding: screen.isAdding,
			isAdded: screen.isAdded,
			isUpdating: screen.isUpdating,
			isUpdated: screen.isUpdated,
			isLoadingList: screen.isLoadingList,
			requireCloseModal: screen.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorScreen);

	// validation
	const validation = useFormik({
		initialValues: {
			name: (dataScreen && dataScreen.name) || '',
			description: (dataScreen && dataScreen.description) || '',
			fields: (dataScreen && dataScreen.fields) || [
				[
					{
						field_id: '',
						optional: false,
						size: 4,
					},
				],
			],
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			description: Yup.string().required('Campo requerido'),
			fields: Yup.array().of(
				Yup.array().of(
					Yup.object().shape({
						field_id: Yup.string().required('Campo requerido'),
						optional: Yup.boolean().required('Campo requerido'),
						size: Yup.number().required('Campo requerido'),
					})
				)
			),
		}),
		onSubmit: values => {
			const screen = {
				name: values.name,
				description: values.description,
				fields: values.fields,
			};

			console.log(values);

			if (isEdit) {
				screen._id = dataScreen._id;
				dispatch(updateScreen(screen));
			} else {
				dispatch(addNewScreen(screen));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	useEffect(() => {
		getFieldList().then(response => setFieldsList(response));
	}, []);

	return (
		<>
			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => {
								toggleTab('1');
							}}
						>
							Información General
						</NavLink>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '2' })}
							onClick={() => {
								toggleTab('2');
							}}
						>
							Campos
						</NavLink>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '3' })}
							onClick={() => {
								toggleTab('3');
							}}
						>
							Disposición
						</NavLink>
					</NavItem>
				</Nav>
			</div>
			<Form
				className='tablelist-form'
				onSubmit={e => {
					e.preventDefault();

					validation.handleSubmit();
					return false;
				}}
			>
				<ModalBody className='modal-body'>
					<TabContent activeTab={activeTab}>
						<TabPane tabId='1'>
							<Row className='g-3'>
								<Col lg={8}>
									<Label for='name' className='form-label'>
										Nombre
									</Label>
									<Input
										name='name'
										id='name'
										className='form-control'
										placeholder='Ingrese un nombre'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.name || ''}
										invalid={
											validation.touched.name &&
											validation.errors.name
												? true
												: false
										}
									/>
									{validation.touched.name &&
									validation.errors.name ? (
										<FormFeedback type='invalid'>
											{validation.errors.name}
										</FormFeedback>
									) : null}
								</Col>
								<Col lg={4}>
									<Label for='description' className='form-label'>
										Descripción
									</Label>
									<Input
										name='description'
										id='description'
										className='form-control'
										placeholder='Ingrese una descripción'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.description || ''}
										invalid={
											validation.touched.description &&
											validation.errors.description
												? true
												: false
										}
									/>
									{validation.touched.description &&
									validation.errors.description ? (
										<FormFeedback type='invalid'>
											{validation.errors.description}
										</FormFeedback>
									) : null}
								</Col>
							</Row>
						</TabPane>
						<TabPane tabId='2'>
							{validation.values.fields.map((row, indexRow) =>
								row.map((campo, indexCampo) => (
									<Row
										className='g-3'
										key={`${indexRow}-${indexCampo}`}
									>
										<Col lg={8}>
											<Label for='field_id' className='form-label'>
												Campo
											</Label>
											<Select
												name='field_id'
												placeholder='Seleccione un campo'
												value={
													validation.values.fields[indexRow][
														indexCampo
													].field_id
												}
												onChange={value => {
													const campos = [
														...validation.values.fields,
													];
													campos[indexRow][indexCampo].field_id =
														value;
													validation.setFieldValue(
														'fields',
														campos
													);
												}}
												data={fieldsList.map(field => ({
													label: `${field.name} - ${field.field_type.name}`,
													value: field._id,
												}))}
											/>
										</Col>
										<Col lg={2}>
											<div className='d-flex'>
												<div>
													<FormGroup className='d-flex gap-2 align-items-center'>
														<Label className=''>
															<div className='d-flex'>
																<Input
																	type='checkbox'
																	checked={
																		validation.values.fields[
																			indexRow
																		][indexCampo].optional
																	}
																	onChange={e => {
																		const campos = [
																			...validation.values
																				.fields,
																		];
																		campos[indexRow][
																			indexCampo
																		].optional =
																			e.target.checked;
																		validation.setFieldValue(
																			'fields',
																			campos
																		);
																	}}
																/>
																<div className='px-1'>
																	Opcional
																</div>
															</div>
														</Label>
														{validation.touched.optional &&
														validation.errors.optional ? (
															<FormFeedback type='invalid'>
																{validation.errors.optional}
															</FormFeedback>
														) : null}
													</FormGroup>
												</div>
											</div>
										</Col>
										<Col lg={2}>
											<Button
												onClick={() => {
													const campos = [
														...validation.values.fields,
													];
													campos[indexRow].splice(indexCampo, 1);
													validation.setFieldValue(
														'fields',
														campos
													);
												}}
												className='btn btn-danger'
											>
												Eliminar
											</Button>
										</Col>
									</Row>
								))
							)}
							<Button
								onClick={() => {
									const campos = [...validation.values.fields];
									campos[campos.length - 1].push({
										field_id: '',
										optional: false,
										size: 4,
									});

									validation.setFieldValue('fields', campos);
								}}
								className='btn btn-primary'
							>
								Agregar
							</Button>
						</TabPane>
						<TabPane tabId='3'>hola</TabPane>
					</TabContent>
				</ModalBody>
				<div className='modal-footer'>
					<div className='hstack gap-2 justify-content-end'>
						<Button
							type='button'
							onClick={() => {
								handleToggleModal();
							}}
							className='btn-danger btn-label'
						>
							<i className='icon-x label-icon'></i>
							Cancelar
						</Button>
						<button
							type='submit'
							className='btn btn-label btn-primary'
							id='add-btn'
							disabled={isAdding || isUpdating}
						>
							{isAdding || isUpdating ? (
								<i className='label-icon'>
									<Spinner size='sm' />
								</i>
							) : (
								<i className='ri-save-3-line label-icon'></i>
							)}
							{isEdit ? 'Editar' : 'Crear'} Pantalla
						</button>
					</div>
				</div>
			</Form>
		</>
	);
};

export default ScreenForm;
